import { Injectable } from "@angular/core";

import { environment } from "@env";

@Injectable({ providedIn: "root" })
export class ApiConfig {
  readonly baseUrl = environment.apiBaseUrl;

  buildUrl(path: string): string {
    return `${this.baseUrl}/${path.replace(/^\//, "")}`;
  }
}
